import { useState } from 'react';
import {
  Button,
  Form,
  Label,
  Icon,
  Collapsible,
  IconNameType,
} from '@servicetitan/design-system';
import { EditContactsValidationType } from '@pages/agent/InboxPage/components/ContactsDrawers/validations';
import { CreateCustomerFormValues } from '@components/CreateCustomer/components/CreateCustomerForm/CreateCustomerFormDefinitions';
import { useFormContext, Controller } from 'react-hook-form';
import { ContactFormPrefixes } from '@components/forms/components/ContactMethodForm';

type NotificationsCollapsibleProps = {
  formFieldPrefix: ContactFormPrefixes;
  label?: string;
  iconName?: IconNameType;
  index: number;
};

// Note: Can refactor to be more reusable later
export function NotificationsCollapsible({
  formFieldPrefix,
  iconName,
  index,
  label,
}: NotificationsCollapsibleProps) {
  const [open, setOpen] = useState(false);

  const { control } = useFormContext<
    CreateCustomerFormValues & EditContactsValidationType
  >();

  return (
    <>
      <Button
        className='p-x-0 m-b-0'
        fill='subtle'
        iconName={iconName ?? 'notifications'}
        iconPosition='left'
        onClick={() => setOpen(!open)}
        small
      >
        <Label className='m-r-1'>{label ?? 'Notifications'}</Label>
        <Icon name={open ? 'expand_less' : 'expand_more'} />
      </Button>
      <Collapsible animate open={open}>
        <Controller
          control={control}
          name={`${formFieldPrefix}.contacts.${index}.jobRemindersEnabled`}
          render={({ field }) => (
            <Form.Checkbox
              className='m-t-2 m-b-2 m-l-1'
              label='Job Notifications'
              size='small'
              checked={field.value}
              onChange={(_val, checked) => {
                field.onChange(checked);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name={`${formFieldPrefix}.contacts.${index}.invoiceStatementNotification`}
          render={({ field }) => (
            <Form.Checkbox
              className='m-b-2 m-l-1'
              label='Invoice Notifications'
              size='small'
              checked={field.value}
              onChange={(_val, checked) => {
                field.onChange(checked);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name={`${formFieldPrefix}.contacts.${index}.marketingUpdatesEnabled`}
          render={({ field }) => (
            <Form.Checkbox
              className='m-b-2 m-l-1'
              label='Marketing Notifications'
              size='small'
              checked={field.value}
              onChange={(_val, checked) => {
                field.onChange(checked);
              }}
            />
          )}
        />
      </Collapsible>
    </>
  );
}
